/*
 * @created: Wednesday, 1st April 2020 2:49:29 pm
 * @author: github.com/huangbinjie
 * @file: 橙色
 *
 * Copyright 2020 Qiniu
 */
var Orange;
(function (Orange) {
    Orange["orange1"] = "#FDE28F";
    Orange["orange2"] = "#FDD578";
    Orange["orange3"] = "#FCC660";
    Orange["orange4"] = "#FBB547";
    Orange["orange5"] = "#FAA12F";
    Orange["orange6"] = "#FA8C16";
    Orange["orange7"] = "#DF7211";
    Orange["orange8"] = "#C75D0D";
    Orange["orange9"] = "#AD490A";
    Orange["orange10"] = "#943807";
})(Orange || (Orange = {}));
export default Orange;
//# sourceMappingURL=orange.js.map